module.exports = __webpack_public_path__ + "static/media/play-endgame-start.3e8eeb04.mp3";